module.exports = __webpack_public_path__ + "img/m-cash.99f59b23.svg";